<template>
  <el-dialog class="glass-dialog" :model-value="modelValue" @update:model-value="emit('update:modelValue', $event)" :fullscreen="isMobile" :width="dialogWidth" destroy-on-close align-center>
    <GalleryDetailVue v-if="activeId" :work-id="activeId" :show-breadcrumb="false" layout="modal">
      <template #videoOverlay>
        <el-button class="border-none backdrop-blur nav-btn left bg-white/80" circle :icon="ArrowLeftBold" @click="prev" :disabled="works.length <= 1" />
        <el-button class="border-none backdrop-blur nav-btn right bg-white/80" circle :icon="ArrowRightBold" @click="next" :disabled="works.length <= 1" />
      </template>
    </GalleryDetailVue>
  </el-dialog>
</template>

<script setup lang="ts">
import { ArrowLeftBold, ArrowRightBold } from '@element-plus/icons-vue'
import GalleryDetailVue from '~/components/GalleryDetailVue/index.vue'

type WorkItem = {
  id: number
}

const props = defineProps<{
  modelValue: boolean
  works: WorkItem[]
  activeId?: number
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
  (e: 'update:activeId', value: number | undefined): void
}>()

const isMobile = ref(false)
const dialogWidth = ref('80%')

const updateLayout = () => {
  if (typeof window === 'undefined') {
    return
  }
  const width = window.innerWidth
  isMobile.value = width < 768
  dialogWidth.value = width < 1024 ? '95%' : '70%'
}

onMounted(() => {
  updateLayout()
  if (typeof window !== 'undefined') {
    window.addEventListener('resize', updateLayout, { passive: true })
  }
})

onBeforeUnmount(() => {
  if (typeof window !== 'undefined') {
    window.removeEventListener('resize', updateLayout)
  }
})

const activeIndex = computed(() => {
  const list = props.works || []
  if (!props.activeId) {
    return list.length > 0 ? 0 : -1
  }
  const index = list.findIndex((w: WorkItem) => w.id === props.activeId)
  return index >= 0 ? index : list.length > 0 ? 0 : -1
})

const activeId = computed(() => {
  const list = props.works || []
  const index = activeIndex.value
  return index >= 0 && list[index] ? list[index].id : undefined
})

watch(
  () => props.modelValue,
  (visible: boolean) => {
    if (!visible) {
      return
    }
    if (!props.activeId && activeId.value) {
      emit('update:activeId', activeId.value)
    }
  },
)

const next = () => {
  const total = props.works.length
  if (total <= 0) {
    return
  }
  const nextIndex = (activeIndex.value + 1) % total
  emit('update:activeId', props.works[nextIndex] ? props.works[nextIndex].id : undefined)
}

const prev = () => {
  const total = props.works.length
  if (total <= 0) {
    return
  }
  const prevIndex = (activeIndex.value - 1 + total) % total
  emit('update:activeId', props.works[prevIndex] ? props.works[prevIndex].id : undefined)
}
</script>

<style scoped>
.nav-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.nav-btn.left {
  left: 12px;
}

.nav-btn.right {
  right: 12px;
}
</style>
